import { useUrlParams } from "src/global/utils/urlParams.ts"
import { ExpectationType } from "src/pages/DataAssets/views/Expectations/ExpectationSelector"
import { anomaly_detection_expectations_created_via } from "src/pages/DataAssets/views/Expectations/ExpectationsTable"

export const useExpectationFilter = <T extends { createdVia?: string | null; autogenerated?: boolean | null }>(
  expectations: T[],
) => {
  const [{ filter }] = useUrlParams<{ filter: ExpectationType }>({ filter: "all" })
  const currentFilter = filter || "all"
  const filteredExpectations = expectations.filter((expectation) => {
    if (!expectation) return false
    if (currentFilter === "all") return true

    const isAnomalyDetection =
      expectation.autogenerated && anomaly_detection_expectations_created_via.includes(expectation.createdVia ?? "")
    return filter === "anomaly_detection" ? isAnomalyDetection : !isAnomalyDetection
  })

  return {
    currentFilter,
    filteredExpectations,
  }
}
